import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ProductCard } from '../components/ProductCard';
import { API_URL } from '../lib/utils';
import { Button } from '../components/ui/button';

export const Shop = () => {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();

  const categories = [
    { value: null, label: 'All Products' },
    { value: 'wellness', label: 'Wellness' },
    { value: 'recovery', label: 'Recovery' },
    { value: 'dental', label: 'Dental' },
    { value: 'cognitive', label: 'Cognitive' },
    { value: 'youth', label: 'Youth' },
    { value: 'kids', label: 'Kids' },
  ];

  useEffect(() => {
    // Check if category is in URL params
    const urlCategory = searchParams.get('category');
    if (urlCategory) {
      setCategory(urlCategory);
    }
  }, [searchParams]);

  useEffect(() => {
    fetchProducts();
  }, [category]);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const url = category ? `${API_URL}/products?category=${category}` : `${API_URL}/products`;
      const response = await axios.get(url);
      // Sort by displayOrder
      const sortedProducts = response.data.sort((a, b) => (a.displayOrder || 999) - (b.displayOrder || 999));
      setProducts(sortedProducts);
    } catch (error) {
      console.error('Failed to fetch products:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen py-12 px-6 lg:px-12 bg-purple-25" data-testid="shop-page">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-heading font-light mb-6" data-testid="shop-title">
            Shop All Products
          </h1>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Discover our complete range of SAC® formulation products, each designed to support
            your body's natural healing processes.
          </p>
        </div>

        {/* Category Filter */}
        <div className="mb-12">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((cat) => (
              <Button
                key={cat.value || 'all'}
                variant={category === cat.value ? 'default' : 'outline'}
                className="rounded-full"
                onClick={() => setCategory(cat.value)}
                data-testid={`category-${cat.value || 'all'}`}
              >
                {cat.label}
              </Button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        {loading ? (
          <div className="text-center py-12" data-testid="loading">
            <p className="text-stone-500">Loading products...</p>
          </div>
        ) : products.length > 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="products-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-stone-500">No products found in this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};